import styled from "styled-components";

export const ContentToolTip = styled.div(({visible}) => ({
    position: "absolute",
    display: visible ? "flex" : "none",
    width: "281px",
    flexDirection: "column",
    alignItems: "flex-start",
    visibility: visible ? 'visible' : 'hidden',
    borderRadius: "0px 8px 8px 8px",
    border: "1px solid #D1DBE3",
    background: "#fff",
    zIndex: 99999,
    margin: "15px 0 0 15px"
}))

export const TextToolTip = styled.p(() => ({
    display: "flex",
    padding: "16px",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: "20px",
    alignSelf: "stretch",
}))